import gflowConfig from 'gflow-config';
import 'whatwg-fetch';
import ready from './core/ready';

__webpack_public_path__ = gflowConfig.public_path; // eslint-disable-line

ready();
